function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import localeKeys from '../../../../../locales/keys';
import { REGEXES } from '../../../../../customercare.constants';
var GrantCouponPopupController = /*#__PURE__*/function () {
  function GrantCouponPopupController() {
    _classCallCheck(this, GrantCouponPopupController);
    this.localeKeys = localeKeys;
    this.viewModel = {
      errorMessages: [],
      emailRegex: REGEXES.EMAIL,
      isGrantingCoupon: false,
      selectedCoupon: null
    };
    this._isInitialized = false;
  }
  return _createClass(GrantCouponPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      this.viewModel.grantCouponModel = {
        SendNotification: true,
        GrantCouponTimes: 1,
        GrantCouponEmail: this.customer.Email
      };
      this._isInitialized = true;
      this.updateViewModel();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      this.updateViewModel();
    }
  }, {
    key: "updateViewModel",
    value: function updateViewModel() {
      if (!this._isInitialized) {
        return;
      }
      this.viewModel.isGrantingCoupon = this.isGrantingCoupon;
      this.viewModel.selectedCoupon = this.selectedCoupon;
      if (this.errorMessage) {
        this.viewModel.errorMessages = [this.errorMessage];
      } else {
        this.viewModel.errorMessages = [];
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.onClose()();
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      if (this.grantCouponPopupForm.$invalid) {
        return;
      }
      var actionData = {
        CouponId: this.selectedCoupon.Id,
        RecipientEmailAddress: this.viewModel.grantCouponModel.GrantCouponEmail,
        RedemptionCodeCount: this.viewModel.grantCouponModel.GrantCouponTimes,
        SendNotification: this.viewModel.grantCouponModel.SendNotification
      };
      this.onSubmit()(actionData);
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      //This function is specially designed to prevent anything from happening when the user hits the "enter key"
      var ENTER_KEYCODE = 13;
      var keyCode = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
      if (keyCode === ENTER_KEYCODE) {
        event.cancelBubble = true;
        event.returnValue = false;
        if (event.stopPropagation) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    }
  }]);
}();
export default {
  template: require('./grant.coupon.popup.html'),
  bindings: {
    customer: '<',
    errorMessage: '<',
    isGrantingCoupon: '<',
    onClose: '&',
    onSubmit: '&',
    selectedCoupon: '<',
    selectedCouponAssociationCardsData: '<'
  },
  controller: GrantCouponPopupController,
  controllerAs: 'GrantCouponPopup'
};